module.exports = __webpack_public_path__ + "static/media/film-prod-city-page-hero.de63105a.jpg";